export default __webpack_public_path__ + "static/minigame-7d3fb864beb26ccfb9f4fa35ae4b812c.png";